<template>
  <el-dialog custom-class="el-popup-parent-imgPop--dialog" class="imgPop" :visible.sync="proVisible" width="950px" :close-on-click-modal='false' append-to-body v-dialogDrag @close="close_dialog">
    <div slot="title" class="header_part">
      <span class="title">{{editId?$t('components_basic_addproduct_index_2077'):$t('components_basic_addproduct_index_2078')}}</span>
      <!-- <span class="titleTip">(建议产品图片大于768*768像素。)</span> -->
    </div>
    <div class="pop_content" v-loading='loading'>
      <div class="tabLine">
        <ul>
          <li v-for="(item, index) in pageList"  :key="index" @click="changeSe(index)"
              v-if="(index != 1 || isFshop)"
              :class="{ active: index == selectLine }">
            <p>{{ item.label }}</p>
          </li>
        </ul>
      </div>
      <div class="showPart">
        <message ref="infoForm" v-show="selectLine === 0" :tagList="tagList" :total='total' :proParams='proParams' :productInfor="product.productInfor" :treeData="tree_data" :articleWords='$t("widgets_basic_classification_edit_482")' @getTypes='getTypes'></message>
        <sales ref="sales"
               v-show="selectLine === 1"
               :optFormOne="optFormOne"
               :optFormAng="optFormAng"
               :p_5="p_5"
               @changeConfirmDisabled="changeConfirmDisabled"
               @getSalesType="getSalesType"
               @getSalesInfo="getSalesInfo">
        </sales>
        <kind_editor :content.sync="product.intro.value" v-if="selectLine === 2" @on-content-change="onContentChange" width='768' height='260'></kind_editor>
        
        <ai_command v-if="selectLine === 2" :type="'wt'" @pushCont="pushCont" :command_type ="'goods_detail'"></ai_command>

        <div v-for="(e, index) in tabs" :key="index">
          <kind_editor v-if="selectLine === index + 3 && e.show_type === 7" :content.sync="e.content" @on-content-change="ontabContentChange(index, $event)" width='768' height='260'></kind_editor>
          <el-button class="downLand_btn" v-if="selectLine === index + 3 && e.show_type === 8" size="small" @click="addFile">{{$t('widgets_basic_download_edit_504')}}</el-button>
          <div class="downlandPart" v-if="selectLine === index + 3 &&e.show_type === 8 &&showDownland">
            <el-table :data="e.content" style="width: 100%">
              <el-table-column prop="name" :label="$t('view_download_index_173')" width="180">
              </el-table-column>
              <el-table-column prop="size" :label="$t('view_download_index_174')" width="180">
                <template slot-scope="scope">
                  <span>{{(scope.row.size/1024).toFixed(1)}}KB</span>
                </template>
              </el-table-column>
              <el-table-column prop="time" :label="$t('widgets_basic_download_display_index_516')">
                <template slot-scope="scope">
                  <span v-if="scope.row.time === 0 || scope.row.time === '0'|| scope.row.time == null"></span>
                  <span v-else>{{ Global.parseTime(scope.row.time, '{y}-{m}-{d} {h}:{i}:{s}') }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('view_form_dialog_add_form_216')">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delItem(scope.$index, e.content)">{{$t('view_god_set_index_226')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <seo ref="infoSeo" v-show="selectLine === 3 + tabs.length" :seoData="product.seo" :productInfor="product.productInfor" :autoSeo='autoSeo' :handerSeo='handerSeo' seoTitleType ="product"></seo>

      </div>
    </div>
    <div class="btn-footer">
      <el-button type="primary" @click="sendData" :loading="loading" :disabled="confirmDisabled">{{$t('components_basic_addproduct_index_2079')}}</el-button>
      <el-button @click="close_dialog" :loading="loading">{{$t('view_public_topbar_14')}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '../../language/index'

import {
  proTypeList,
  getProducttablist,
  addProduct,
  proDetail,
  getTagsList
} from '@/api/app.js';
import message from './message.vue';
import seo from '../basic_common/seo.vue';
import sales from "./sales.vue";
import ai_command from "../ai_command/index.vue";
import { lockScroll } from '@/base/base'
import {mapState} from "vuex";
export default {
  components: {
    message,
    seo,
    sales,
    ai_command,
  },
  data() {
    var myDate = Date.parse(new Date());
    return {
      //单规格数据
      optFormOne:{
        price_market:undefined,
        price_sell:undefined,
        sku:undefined,
        weight:undefined,
        store:undefined,
      },
      //多规格数据
      optFormAng:{
        salesAngTable:[],
        salesAngAttribute:[],
      },
      p_5:1,
      //标签列表
      tagList: [],
      showDownland: true,
      loading: false,
      product: {
        productInfor: {
          goods_id: '', //产品id
          name: '', //产品名称
          pageviews: 0, //浏览量
          album_ids: '', // 多个图片的ID
          type_name: '', //产品分类名称
          type_id: '', //产品分类
          is_up: 'true', //是否发布
          is_nostore: 'true', //无库存销售
          bn: '', // 产品编码
          sort: 0, //产品排序
          img: '', //产品主图
          up_time: myDate, //发布时间
          writer: '', //作者
          imageUrl: [], //产品图片
          summary: '', // 产品简介
          brand: '', //品牌
          standard: '', //规格
          model: '', //型号
          unit: '', //单位
          minimum: 0, //起订量
          pack: '', //包装说明
          custom_attr: [ // 自定义属性  属性名和属性值都是自定义的
            {
              attr_name: '',
              attr_value: ''
            },
            {
              attr_name: '',
              attr_value: ''
            },
            {
              attr_name: '',
              attr_value: ''
            }
          ],
          video_url: '', //产品视频
          video_img: '', // 产品视频封面
          tag_id: '',
          tag_ids: '',
          static: '', //静态文件名
        },
        intro: {
          value: '' //产品详情
        },
        seo: {
          seo_title: '', //SEO标题
          // seo_keywords: [{value: ''},{value: ''},{value: ''}], //SEO关键词
          seo_keywords: [], //SEO关键词
          seo_description: '', //SEO描述
        }
      },
      addTree: [],
      tree_data: [],
      tabs: [],
      total: 0,
      pageList: [{
          label: i18n.t('components_basic_addarticle_index_2006'),
          value: 0
        },
        {
          label: i18n.t('components_basic_addproduct_index_2080'),
          value: 3
        },
        {
          label: i18n.t('components_basic_addproduct_index_2081'),
          value: 1
        },
        {
          label: i18n.t('components_basic_addarticle_index_2008'),
          value: 2
        },
      ],
      proParams: {
        title: i18n.t('components_basic_addproduct_index_2082'),
        type: 'add', // 类型： 新增（add）或编辑(edit)
        twebId: 0, // 网站ID
        pid: '0', // 分类类型pid
        id: '0', // 分类类型ID
        objectType: 'product', //  新增或编辑对象的类型 pro 分类类型
        typevalue: 1,
      },
      autoSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      handerSeo: {
        title: '',
        keywords: '',
        description: ''
      },
      proVisible: true,
      dataVisible: this.showTag,
      typeValue: 1,
      selectLine: 0,
      imgUrl: [],
      content: '',
      item: [
        'clearhtml',
        'selectall',
        'plainpaste',
        'undo',
        'redo',
        'heading',
        'fontname',
        'fontsize',
        'forecolor',
        'hilitecolor',
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'subscript',
        'superscript',
        'align',
        'lineheight',
        'indent',
        'outdent',
        'insertorderedlist',
        'insertunorderedlist',
        'image',
        'flash',
        'link',
        'unlink',
        'media',
        'table',
        'hr',
        'pagebreak',
        'source',
        'fullscreen'
      ],
      confirmDisabled: true,
      isReset: true,
      error:'',
    };
  },
  computed: {
    ...mapState('app',['Fshop']),
    isFshop() {
      //是否有产品销售信息权益
      return this.Fshop
    },
  },
  props: {
    editId: {
      type: Number,
      default: null
    },
    showTag: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    imgUrl(val) {
      // console.log(val);
    },
    dataVisible(val, oldVal) {
      this.$emit('update:showTag', val);
    },
    product: {
      handler() {
        if (!this.isReset) {
          this.confirmDisabled = false
        } else {
          this.confirmDisabled = true
          this.isReset = false
        }
      },
      deep: true
    },
    tabs: {
      handler(val, oldVal) { // 因为初始化赋值的的时候 tabs就会发生变化 由[] 开始变化
        // console.log('tab 标签发生辩护', val)
        if (oldVal.length > 0) {
          this.confirmDisabled = false
        }
      },
      deep: true
    }
  },
  methods: {
    changeConfirmDisabled(val){
      this.confirmDisabled = false
    },
    getSalesType(type){
      this.p_5 = type
    },
    getSalesInfo(error){
      this.error = error
    },
    closeChange(){

    },
    getTagList() {
      getTagsList().then(res => {
        if (res.code == 200) {
          this.tagList = res.data;
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getTypes() {
      // 获取产品类型ID
      this.loading = true;
      let data = {
        hide: 'false'
      }
      proTypeList(data)
        .then(res => {
          if (res.code === 200 && res.data && res.data.rows instanceof Array) {
            this.tree_data = res.data.rows.map(item => {
              return item;
            });
            let addtree = [];
            addtree = res.data.rows.map(item => {
              return item;
            });
            this.addTree = addtree;
            this.total = res.data.total
          } else {
            this.tree_data = [];
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProducttablist() {
      let that = this;
      getProducttablist()
        .then(res => {
          if (res.code === 200) {
            if (this.isFshop){
              this.$refs.sales.init(this.optFormOne,this.optFormAng,this.p_5)
            }
            // this.total = parseInt(res.data.total)
            that.tabs = res.data;
            that.tabs = that.tabs.map((item, i) => {
              // 如果item.content 海外建站 content 不存在
              !item.content && (item.content = '')
              if (item.show_type === 8) {
                item.content = item.content ? JSON.parse(item.content) : []
              }
              return item
            })
            let seo = that.pageList[that.pageList.length - 1];
            that.pageList.splice(3, 1);
            that.pageList = that.pageList.concat(res.data);
            that.pageList.splice(res.data.length + 3, 0, seo);
            that.pageList = that.pageList.map((e, i) => {
              if (!e.label) {
                e.label = e.name;
              }
              e.value = i;
              return e;
            });
            // console.log(that.pageList);
          } else {
            this.tabs = [];
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onContentChange(content) {
      this.product.intro.value = content;
    },
    // ai 内容推送
    pushCont(data){
      this.product.intro.value = data.content;
      this.product.productInfor.summary = data.summary;
    },
    ontabContentChange(index, val) {
      this.tabs[index].content = val;
    },
    changeSe(index) {
      this.selectLine = index;
    },
    closepage() {
      this.$nextTick(() => {
        lockScroll(false)
      })
      if (this.loading) {
        return false
      }
      // this.dataVisible = false;
      this.proVisible = true;
      this.$emit('closed');
    },
    sendData() {
      let tag = true;
      this.$refs.infoForm.$refs.product_infor.validate(valid => {
        tag = valid;
      });
      if (!tag) {
        this.selectLine = 0;
        let isError = document.getElementsByClassName("is-error");
        let errClass = $(isError).parent().attr('class');
        if (isError.length > 0) {
            if(errClass != 'attrnormspart' && errClass != 'attrnormspart'){
                this.$nextTick(() => {
                  isError[0].scrollIntoView({
                    // 滚动到指定节点
                    // 值有start,center,end，nearest，当前显示在视图区域中间
                    block: "center",
                    // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                    behavior: "smooth"
                  });
                  return false;
              });
            }else{
              this.$refs.infoForm.setActiveNames()
              let infoForm = this.$refs.infoForm
              setTimeout(function(){infoForm.scrollIntoError()}, 200)
            }
        }
        return false;
      }
      let sendData = {};
      if (this.product.productInfor.imageUrl.length > 0) {
        this.sendData.img = this.product.productInfor.imageUrl[0].filePath;
      }
      if (this.product.seo.seo_keywords) {
        this.product.seo.seo_keywords.map(item => {
          item.value = item.value.replace(/[\uff0c]/g, ",")
        })
      }
      if (!this.product.seo.seo_title) {
        // this.product.seo.seo_title = this.product.productInfor.name;
      }
      if (!this.product.seo.seo_keywords) {
        // this.product.seo.seo_keywords = this.product.productInfor.name;
      }
      if (!this.product.seo.seo_description) {
        // this.product.seo.seo_description = this.product.productInfor.summary;
      }
      sendData = this.product.productInfor;
      let tabs = {};
      this.tabs.map(e => {
        tabs[e.id] = {};
        tabs[e.id].content = e.content;
        if (e.show_type === 8) {
          tabs[e.id].content = JSON.stringify(e.content)
        }
      });
      sendData.tabs = tabs;
      let album_ids = [];
      for (let i = 0; i < this.product.productInfor.imageUrl.length; i++) {
        album_ids.push(this.product.productInfor.imageUrl[i].filePath);
      }
      if (this.product.productInfor.imageUrl.length > 0) {
        sendData.img = this.product.productInfor.imageUrl[0].filePath
      } else {
        sendData.img = ''
      }
      // 判断产品主图不能为空
      if (this.product.productInfor.imageUrl.length === 0) {
        this.$message.error(i18n.t('components_basic_addproduct_index_2083'));
        return;
      }
      sendData.album_ids = album_ids.join(',');
      sendData.intro = this.product.intro.value;
      sendData.is_up = this.product.productInfor.is_up;
      sendData.seo_title = this.product.seo.seo_title;
      sendData.seo_keywords = this.product.seo.seo_keywords;
      sendData.keyWords = this.product.seo.seo_keywords;
      sendData.seo_description = this.product.seo.seo_description;
      if (this.editId) {
        sendData.goods_id = this.editId
      }
      if (!sendData.intro) {
        this.selectLine = 1;
        this.$message.error(i18n.t('components_basic_addproduct_index_2084'));
        return;
      }
      if (!sendData.video_url && sendData.video_img) {
        this.$message.error(i18n.t('components_basic_addproduct_index_2085'));
        return;
      }
      this.$refs.infoSeo.$refs.seo_data.validate(valid => {
        tag = valid;
      });
      if(!tag){
        this.selectLine = this.pageList.length - 1;
        return false;
      }
      if (sendData.up_time.length == 13) {
        sendData.up_time = sendData.up_time / 1000
      }
      sendData.custom_attr = this.product.productInfor.custom_attr.filter(item => item.attr_name && item.attr_value)
      if (this.isFshop){
        if (this.optFormAng.salesAngAttribute.length <= 0 && this.p_5 === 2){
          this.$message.warning(i18n.t('components_basic_addproduct_index_2086'));
          return false;
        }
        if (this.optFormAng.salesAngTable.length <= 0 && this.p_5 === 2){
          this.$message.warning(i18n.t('components_basic_addproduct_index_2087'));
          return
        }
        if (this.p_5 === 2){
          const tagDataArrIsEmpty = this.optFormAng.salesAngAttribute.find(item => item.tagDataArr.length <= 0)
          if (tagDataArrIsEmpty){
            this.$message.warning(tagDataArrIsEmpty.tagTitle+i18n.t('components_basic_addproduct_index_2088'));
            return
          }
        }
        // 过滤自定义属性 this.paramData  == 要保留一个空值放到最后
        let optFormOne = {
          price_market:this.optFormOne.price_market === undefined ? '' : this.optFormOne.price_market,
          price_sell:this.optFormOne.price_sell === undefined ? '' : this.optFormOne.price_sell,
          sku:this.optFormOne.sku === undefined ? '' : this.optFormOne.sku,
          weight:this.optFormOne.weight === undefined ? '' : this.optFormOne.weight,
          store:this.optFormOne.store === undefined ? '' : this.optFormOne.store,
        }
        sendData.optFormOne = optFormOne
        sendData.optFormAng = this.optFormAng
        sendData.p_5 = this.p_5
        if (this.p_5 === 1){
          this.$refs.sales.$refs.optFormOne.validate((valid, data) =>{
            if (!valid){
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                let errClass = $(isError).parent().attr('class');
                if (isError.length > 0) {
                  if(errClass != 'attrnormspart' && errClass != 'attrnormspart'){
                    this.$nextTick(() => {
                      isError[0].scrollIntoView({
                        // 滚动到指定节点
                        // 值有start,center,end，nearest，当前显示在视图区域中间
                        block: "center",
                        // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                        behavior: "smooth"
                      });
                      return false;
                    });
                  }else{
                    this.$refs.infoForm.setActiveNames()
                    let infoForm = this.$refs.infoForm
                    setTimeout(function(){infoForm.scrollIntoError()}, 200)
                  }
                }
              });
            }else {
              this.addProductFun(sendData);
            }
          })
        }
        if (this.p_5 === 2){
          this.$refs.sales.$refs.optFormAng.validate((valid, data) =>{
            if (!valid){
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                let errClass = $(isError).parent().attr('class');
                if (isError.length > 0) {
                  if(errClass != 'attrnormspart' && errClass != 'attrnormspart'){
                    this.$nextTick(() => {
                      isError[0].scrollIntoView({
                        // 滚动到指定节点
                        // 值有start,center,end，nearest，当前显示在视图区域中间
                        block: "center",
                        // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                        behavior: "smooth"
                      });
                      return false;
                    });
                  }else{
                    this.$refs.infoForm.setActiveNames()
                    let infoForm = this.$refs.infoForm
                    setTimeout(function(){infoForm.scrollIntoError()}, 200)
                  }
                }
              });
            }else {
              this.addProductFun(sendData);
            }
          })
        }
      }else {
        this.addProductFun(sendData);
      }
    },
    getStaticStr(name) {
      let str = name
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9-\s]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
      return str;
    },
    addProductFun(sendData){
      if (this.error !== ''){
        this.error = '';
        return false;
      }
      this.loading = true
      let that = this
      // 321938 没有静态文件名的时候就赋值一个
      if(sendData.name && !sendData.static){
        sendData.static =  this.getStaticStr(sendData.name)
      }
      if (sendData.static) {
        sendData.static = this.getStaticStr(sendData.static);
      }
      addProduct(sendData).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message);
          if (this.editId) {
            // this.$emit('closed');
            this.$emit('submit_sure', res.data);
            this.closepage();
          } else {
            this.$confirm(i18n.t('components_basic_addproduct_index_2089'), {
              confirmButtonText: i18n.t('view_public_topbar_15'),
              cancelButtonText: i18n.t('components_basic_addarticle_index_2016'),
              type: 'warning'
            }).then(() => {
              // 确定
              // that.$message.success(res.message);
              // that.$emit('closed');
              that.$emit('submit_sure', res.data);
              that.closepage();
            }).catch((err) => {
              // 继续添加
              that.$emit('submit_sure', res.data);
              this.clearData()
            })
          }
          // this.$message.success(res.message);
          // this.$emit('closed');
          // this.$emit('submit_sure',res.data);
          // this.closepage();
        } else {
          if (sendData.up_time.length == 10) {
            sendData.up_time = sendData.up_time * 1000
          }
          this.$message.error(res.message);
          // 不想写 但是测试提了bug 暂时这样吧
          if (res.message === i18n.t('components_basic_addproduct_index_2090')) this.selectLine = 1
        }
        // this.loading = false;
        // this.isloading = false;
      }).finally(() => {
        this.loading = false
      });
    },
    getProDetail() {
      this.loading = true;
      proDetail({
          id: this.editId
        })
        .then(res => {
          if (res.code == 200) {
            this.setInfo(res.data);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    delItem(index, rows) {
      rows.splice(index, 1);
      this.confirmDisabled = false
    },
    addFile() {
      let content = ''
      let index_content = 0
      this.tabs = this.tabs.map((e, index) => {
        // if (this.selectLine === index + 2) {   不知道为啥这样写
        if (e.show_type === 8) {
          content = e.content || []
          index_content = index
        }
        return e
      })
      let _that = this
      this.$store.commit('image_upload/set_fileType', this.$store.state.image_upload.TYPE_MY_FILE);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 10);
      this.$store.state.image_upload.imgFile = (e) => {
        this.showDownland = false
        let list = []
        e.map(item => {
          let data = {
            name: item.fileName,
            size: item.fileSize,
            time: new Date().getTime(),
            path: item.filePath
          }
          let tag = true
          content.map(x => {
            if (x.path === item.filePath) {
              tag = false
            }
          })
          if (tag) {
            list.push(data)
          }
        })
        _that.tabs[index_content].content = _that.tabs[index_content].content.concat(list)
        _that.$store.state.image_upload.imgFile = null
        this.showDownland = true
        this.confirmDisabled = false
      }
    },
    setInfo(proInfo) {
      // console.log(proInfo)
      // tabs标签修改
      if (this.isFshop){
        if(proInfo.info.optFormOne){
          this.optFormOne = {...proInfo.info.optFormOne};
        }
        if(proInfo.info.optFormAng){
          this.optFormAng = {...proInfo.info.optFormAng};
        }
        if(proInfo.info.p_5){
          this.p_5 = proInfo.info.p_5;
        }
        let optFormOne = {
          price_market:this.optFormOne.price_market === '0.00' ? undefined : this.optFormOne.price_market,
          price_sell:this.optFormOne.price_sell === '0.00' ? undefined : this.optFormOne.price_sell,
          sku:this.optFormOne.sku === '' ? undefined : this.optFormOne.sku,
          weight:this.optFormOne.weight === '0.00' ? undefined : this.optFormOne.weight,
          store:this.optFormOne.store,
        }
        if (this.optFormOne.sku === ''){
          optFormOne.store = undefined;
        }
        this.optFormOne = optFormOne
        this.$refs.sales.init(this.optFormOne,this.optFormAng,this.p_5)
      }
      let tabs = proInfo.info.tabs ? proInfo.info.tabs : [];
      this.tabs = tabs.map((item, i) => {
        if (item.show_type === 8) {
          item.content = item.content ? typeof item.content == "string" ? JSON.parse(item.content) : item.content : [];
        }
        return item
      })
      if (tabs.length > 0) {
        let that = this
        let seo = that.pageList[that.pageList.length - 1];
        that.pageList.splice(3, 1);
        that.pageList = that.pageList.concat(tabs);
        that.pageList.splice(tabs.length + 3, 0, seo);
        that.pageList = that.pageList.map((e, i) => {
          if (!e.label) {
            e.label = e.name;
          }
          e.value = i;
          return e;
        });
      }

      this.product.lengthchange = (this.tabs.length + 3).toString();
      this.product.productInfor.name = proInfo.info.name;
      this.product.productInfor.static = proInfo.info.static;
      this.product.productInfor.summary = proInfo.info.summary;
      this.product.productInfor.brand = proInfo.info.brand;
      this.product.productInfor.standard = proInfo.info.standard;
      this.product.productInfor.model = proInfo.info.model;
      this.product.productInfor.unit = proInfo.info.unit;
      for (let index in proInfo.info.album) {
        let data = {
          filePath: proInfo.info.album[index],
          id: index
        };
        this.product.productInfor.imageUrl.push(data);
      }
      this.product.productInfor.minimum = proInfo.info.minimum;
      this.product.productInfor.pack = proInfo.info.pack;
      this.product.intro.value = proInfo.info.intro;
      let type_name = proInfo.navigation;
      if (proInfo.navigation.lastIndexOf('>') > 0) {
        type_name = proInfo.navigation.substr(proInfo.navigation.lastIndexOf('>') + 1, proInfo.navigation.length);
      }
      this.product.productInfor.type_name = type_name[type_name.length - 1];
      this.product.productInfor.type_id = proInfo.info.type_id;
      this.product.productInfor.is_up = proInfo.info.is_up;
      this.product.productInfor.is_nostore = proInfo.info.is_nostore;
      this.product.productInfor.sort = proInfo.info.sort;
      this.product.productInfor.auto_issue = proInfo.info.auto_issue * 1000;
      this.product.productInfor.up_time = proInfo.info.up_time * 1000
      this.product.productInfor.tag_ids = proInfo.info.tag_ids
      this.product.productInfor.tag_id = proInfo.info.tag_ids
      this.product.seo.seo_title = proInfo.info.seo.title;
      let seo_keywords = []
      if (proInfo.info.seo.keywords.length !== 0 && proInfo.info.seo.keywords.split(',').length > 0) {
        proInfo.info.seo.keywords.split(',').map((item, index) => {
          seo_keywords.push({
            value: item
          })
        })
      } else {
        seo_keywords = []
      }
      this.product.seo.seo_keywords = seo_keywords;
      this.product.seo.seo_description = proInfo.info.seo.description;

      this.handerSeo.keywords = this.product.seo.seo_keywords;
      this.handerSeo.description = this.product.seo.seo_description;
      this.handerSeo.title = this.product.seo.seo_title;
      this.autoSeo.keywords = this.product.seo.seo_keywords;
      this.autoSeo.description = this.product.seo.seo_description;
      this.autoSeo.title = this.product.seo.seo_title;
      this.product.productInfor.img = proInfo.info.img;
      // 自定义属性 以及视频封面 视频详情
      // this.product.productInfor.custom_attr = [...proInfo.info.custom_attr, ...this.product.productInfor.custom_attr].slice(0, 3)
      this.product.productInfor.custom_attr = [...proInfo.info.custom_attr]
      if(this.product.productInfor.custom_attr.length === 0){
        this.product.productInfor.custom_attr.push({
          attr_name: '',
          attr_value: ''
        })
      }
      this.product.productInfor.video_url = proInfo.info.video_url;
      this.product.productInfor.video_img = proInfo.info.video_img;
    },
    close_dialog() {
      this.proVisible = true
      if (!this.confirmDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          //this.proVisible = false
          this.$emit('closed');
          this.$nextTick(() => {
            lockScroll(false)
          })
        }).catch(() => {
          // 啥也不做
        })
      } else {
        // 保存
        //this.proVisible = false
        this.$emit('closed')
        this.$nextTick(() => {
          lockScroll(false)
        })
      }
    },
    clearData() {
      this.isReset = true
      var myDate = Date.parse(new Date())
      this.product = {
        productInfor: {
          goods_id: '', //产品id
          name: '', //产品名称
          pageviews: 0, //浏览量
          album_ids: '', // 多个图片的ID
          type_name: '', //产品分类名称
          type_id: '', //产品分类
          is_up: 'true', //是否发布
          is_nostore: 'true', //无库存销售
          bn: '', // 产品编码
          sort: 0, //产品排序
          img: '', //产品主图
          up_time: myDate, //发布时间
          writer: '', //作者
          imageUrl: [], //产品图片
          summary: '', // 产品简介
          brand: '', //品牌
          standard: '', //规格
          model: '', //型号
          unit: '', //单位
          minimum: '', //起订量
          pack: '', //包装说明
          custom_attr: [ // 自定义属性  属性名和属性值都是自定义的
            {
              attr_name: '',
              attr_value: ''
            },
            {
              attr_name: '',
              attr_value: ''
            },
            {
              attr_name: '',
              attr_value: ''
            }
          ],
          video_url: '', //产品视频
          video_img: '', // 产品视频封面
          static: '', //静态文件名
        },
        intro: {
          value: '' //产品详情
        },
        seo: {
          seo_title: '', //SEO标题
          seo_keywords: [], //SEO关键词
          seo_description: '', //SEO描述
        }
      }
      this.$refs.infoForm.resetFields()
    },
    getAiContent(cont){

    }
  },
  mounted() {
    lockScroll(true)
    if (this.editId) {
      this.getProDetail() // 产品详情中本来就会含有tabs标签 编辑
    } else this.getProducttablist(); // tab 标签初始化 产品新增的时候调用的
    this.getTypes();
    this.getTagList()
  }
};

</script>
<style scoped lang="scss">
@import '~@/css/global-variable.scss';

.imgPop {
  height: 100%;

  /deep/ .el-dialog {
    max-height: 690px;
    height: 690px;
    background: #fff;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      height: 100%;

      .btn-footer {
        width: 100%;
        text-align: center;
        display: block;
        padding-top: 20px;

        .el-button {
          margin: 8px 18px;
          padding: 0 28px;
          height: 34px;
        }
      }
    }

    .el-dialog__footer {
      padding: 0;
    }
  }

  .header_part {
    height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #e3e2e8;

    .title {
      font-size: 16px;
      line-height: 1;
      color: #333;
      line-height: 50px;
    }

    .titleTip {
      font-size: 12px;
      line-height: 1;
      color: #666;
      margin-left: 5px;
      line-height: 50px;
    }
  }

  .pop_content {
    width: 100%;
    font-size: 0;
    display: flex;
    border-bottom: 1px solid #e3e2e8;
    height: calc(100% - 150px);

    .tabLine {
      display: inline-block;
      vertical-align: top;
      font-size: 12px;
      width: 142px;
      height: 100%;
      text-align: center;
      flex-shrink: 0;
      border-right: 1px solid #e3e2e8;

      ul {
        margin-right: -1px;
        max-height: 100%;
        overflow: auto;
      }

      li {
        height: 60px;
        line-height: 60px;
        cursor: pointer;
        border: 1px solid transparent;
        border-left: 0;
        border-right-color: #e3e2e8;
        transition: border-bottom 0.2s ease, border-top 0.2s ease;
        margin-top: -1px;
        position: relative;
        padding-left: 6px; // 左侧 active absolute

        p {
          // width: 100%;
          font-size: 14px;
          line-height: 65px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      li.active {
        color: $theme-primary;
        border-right-color: #fff;
        border-top-color: #e3e2e8;
        border-bottom-color: #e3e2e8;
        font-size: 14px;
      }

      li.active:before {
        content: '';
        width: 6px;
        background-color: $theme-primary;
        height: 59px;
        position: absolute;
        left: 0;
        top: 0;
      }

      li:first-child {
        border-top: 0;
      }
    }

    .showPart {
      display: inline-block;
      vertical-align: top;
      margin-top: 40px;
      height: calc(100% - 40px);
      padding: 0 20px 10px 20px;
      overflow-y: auto;
      .childPagePart {
        width: 745px;
      }
      .childPagePart ::-webkit-scrollbar{
        z-index: 10;
      }
    }
  }
}

.downlandPart {
  width: 760px;
}

</style>



// WEBPACK FOOTER //
// src/components/basic_addProduct/index.vue